import {
  COMPLETED_RENEWALS_PORTAL_URL,
  HOME_URL,
  IMITATE_EMPLOYEE_URL
} from '../route-names';

export const GM = {
  name: 'GM',
  homeUrl: HOME_URL,
  imitable: true,
  displayName: 'user.GM',
  rank : 1
};

export const COM = {
  name: 'COM',
  homeUrl: HOME_URL,
  imitable: true,
  displayName: 'user.COM',
  rank : 2
};

export const CSM = {
  name: 'CSM',
  homeUrl: HOME_URL,
  imitable: true,
  displayName: 'user.CSM',
  rank: 3
};

export const CSR = {
  name: 'CSR',
  homeUrl: HOME_URL,
  imitable: true,
  displayName: 'user.CSR',
  rank : 4
};

export const CAM = {
  name: 'CAM',
  homeUrl: COMPLETED_RENEWALS_PORTAL_URL,
  imitable: true,
  displayName: 'user.CAM',
  rank: 5
};

export const C3 = {
  name: 'C3',
  homeUrl: COMPLETED_RENEWALS_PORTAL_URL,
  imitable: false,
  displayName: 'user.C3',
  rank: 5
};

export const ADMIN = {
  name: 'ADMIN',
  homeUrl: IMITATE_EMPLOYEE_URL,
  imitable: false,
  displayName: 'user.ADMIN',
  rank: 5
};

export const VPO = {
  name: 'VPO',
  homeUrl: COMPLETED_RENEWALS_PORTAL_URL,
  imitable: false,
  displayName: 'user.VPO',
  rank: 5
};

export const RVP = {
  name: 'RVP',
  homeUrl: HOME_URL,
  imitable: true,
  displayName: 'user.RVP',
  rank: 5
};

export const RMT = {
  name: 'RMT',
  homeUrl: HOME_URL,
  imitable: true,
  displayName: 'user.RMT',
  rank: 5
};
